import React from 'react';
import MenuRight from './MenuRight';
import MenuBottom from './MenuBottom.js';
import CenterButtons from './CenterButtons.js';
import Diamond from './images/Diamond.png';
import ActivityImg from './images/Icon_Battle.png';

function Bosses({changeActiveComponent}) {
  
  const changeComponent = (id) => {
    if (id === 'assign') {
      changeActiveComponent('bossesassign');
    } else if (id === 'assigned') {
      changeActiveComponent('bossesunassign');
    }
  };

  return (
    <section id="bosses">
      <div className="platform-container">
      <div className="platform-activity-container">
          <div className="activity-container">
            <div className="activity-image-container"><img src={ActivityImg}/></div>
            <div className="activity-activity-container"><h2>BOSSFIGHT</h2><p>Challenge one of the hostile bosses and the Kingdom will reward you!
Fights lasts for 30 days. Boss selected randomly</p></div>
            <div className="activity-advantages-container"><h2>ADVANTAGE</h2><p>Fighter ANT defeats bosses faster</p></div>
            <CenterButtons changeComponent={changeComponent} /></div>
          </div>
      </div>
    </section>
  );
}

export default Bosses;